import React, { useEffect, useState } from 'react';
import Loading from './Loading';
import '../styles/_activityTable.scss';

const ActivityTable = ({ activities, loading, dataError }) => {
  const [loadingWait, setLoadingWait] = useState(false);
  useEffect(() => {
    // show loading animation for at least 2 seconds
    setTimeout(function () {
      setLoadingWait(true)
    }, 2000);
  }, [])

  if (dataError !== '') {
    return (
      <p className="table-message">{ dataError }</p>
    )
  }

  if (!loading && activities.length === 0) {
    return (
      <p className="table-message">There are no results with your filter criteria.</p>
    )
  }

  return (
    <div className="activity-table">
      { (loading || !loadingWait) &&
        <Loading></Loading>
      }
      <table>      
        <thead>
          <tr>
            <th>Member #</th>
            <th>Plan</th>
            <th>Approved</th>
            <th>Wash Date</th>
            <th>Member Name</th>
            <th>Access Type</th>
          </tr>
        </thead>
        <tbody>
          {activities && activities.map((result, index) => {
            return (
              <tr key={'activity--' + index} className={`${index % 2 === 1 ? 'highlight' : ''}`}>
                <td>{result.memberNumber}</td>
                <td>{result.plan}</td>
                <td><div className={result.approved === 'confirmed' ? 'approved' : 'denied'}></div></td>
                <td>{result.washDate}</td>
                <td><a href={`mailto:${result.email}`} target="_blank">{result.memberName}</a></td>
                <td>
                  <div className="access-icons">
                    <img src={`/icon_qr_${result.access === 'qr' ? '' : 'in'}active.png`} alt="qr access" />
                    <img src={`/icon_bt_${result.access === 'bt' ? '' : 'in'}active.png`} alt="bluetooth access" />
                    <img src={`/icon_code_${result.access === 'code' ? '' : 'in'}active.png`} alt="code access"/>
                  </div>
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}

export default ActivityTable;